import React, { useState, useEffect, useImperativeHandle, forwardRef } from 'react';
import { Alert, Row, Col, Modal, Input } from 'antd';
import './messageLetter.css';
import { Config } from '../../public/js/config';
const { TextArea } = Input;
import PropTypes from 'prop-types';

import doneButtonImg from '../../public/img/newMessage/DoneButton.png'
import rightImg from '../../public/img/newMessage/Right.png'
import cancelButtonImg from '../../public/img/newMessage/CancelButton.png'

/**
 * 消息提示组件
 * props传参如下
 * 消息提示类型,样式 ['error','success','warning','info']
 *                              error:错误提示框，红色样式
 *                              success:成功提示框，绿色样式
 *                              warning:警告提示框，黄色样式
 *                              info:普通提示框，蓝色样式
 */
let messageLetterDev = (props, ref) => {

    const [content, setContent] = useState("");
    const [isShow, setIsShow] = useState(false);
    const [msg, setMsg] = useState("");

    useImperativeHandle(ref, () => {
        return {
            setContent,
            setIsShow,
            setMsg,
        }
    });

    /**
     * 标题默认值处理
     */
    useEffect(() => {
    }, []);

    const save = ()=>{
        props.done("save", msg);
    }

    const save2 = ()=>{
        props.done("cancel");
    }

    return (
        <Modal
            open={isShow}
            onCancel={null}
            closeIcon={null}
            footer={null}
            className='messageLetter'
            width={750}
            centered
            closable={false}
        >
            <img src={rightImg} className='rightImg' />
            <div className='contentBox'>
                {content}
            </div>
            <Input.TextArea placeholder="Please provide a reference letter from your professors." className="textArea" maxLength={500} rows={3} value={msg} onChange={(e) => setMsg(e.target.value)}/>
            <div className='butArea'>
                <div className='saveButton' onClick={save}><img src={doneButtonImg} /></div>
                <div className='cancelButton' onClick={save2}><img src={cancelButtonImg} /></div>
            </div>
        </Modal>
    )

}

messageLetterDev = forwardRef(messageLetterDev);

messageLetterDev.propTypes = {
    done: PropTypes.func.isRequired,
};

export default messageLetterDev;